import React from 'react';
import { useSelector, useDispatch } from 'react-redux';
import { useLocation, useHistory } from 'react-router-dom';
import { Location, History } from 'history';
import { Col, Button, Badge } from 'antd';
import { FaBell } from 'react-icons/fa';

import { getNotificationState } from '../../../store/notifications/selector';
import { updateUnreadCount } from '../../../store/notifications/actions';
import { colors } from '../../../constants/colors';

export const BellBadge: React.FC = () => {
  const { unread } = useSelector(getNotificationState);
  const dispatch = useDispatch();
  const history: History = useHistory();
  const location: Location = useLocation();

  const handleBellPress = () => {
    history.push('/notifications');
    if (unread !== 0) {
      dispatch(updateUnreadCount());
    }
  };

  const isNotifPath = location.pathname === '/notifications';

  return (
    <Col>
      <Button
        type="link"
        block
        onClick={handleBellPress}
        style={{ display: 'flex', justifyContent: 'center' }}
      >
        <div
          className="header-icon-btn notification-badge"
          style={{
            backgroundColor: isNotifPath ? colors.iconColor : '#b0b0b0',
          }}
        >
          <Badge count={unread}>
            <FaBell size={16} color={colors.white} />
          </Badge>
        </div>
      </Button>
    </Col>
  );
};
